import RoundInput from "@/components/styled/input/RoundInput";
import { borderRadius } from "@/utils/borderRadius";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";

export const SetEditInput = ({
    ref,
    style,
    ...inputProps
}: React.InputHTMLAttributes<HTMLInputElement> & {
    ref?: React.RefObject<HTMLInputElement | null>;
}) => {
    return (
        <RoundInput
            ref={ref}
            className="body2"
            sx={{
                backgroundColor: themeColors.background,
                borderRadius: "2rem",
                height: "4.4rem",
                padding: "0.6rem 1.6rem",
                ...style,
            }}
            {...inputProps}
        />
    );
};

SetEditInput.displayName = "SetEditInput";

export const SetEditTextArea = ({
    ref,
    style,
    ...textAreaProps
}: React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    ref: React.RefObject<HTMLTextAreaElement>;
}) => {
    return (
        <textarea
            ref={ref}
            className="body2"
            style={{
                fontFamily: "var(--knowt-font-name)",
                height: "11.25rem",
                outline: "none",
                paddingLeft: "1.6rem",
                paddingRight: "1rem",
                width: "100%",
                border: "2px solid var(--color-border)",
                color: themeColors.neutralBlack,
                backgroundColor: themeColors.neutralWhite,
                borderRadius: borderRadius.longInput,
                paddingTop: spacing.XS_2,
                paddingBottom: spacing.XS_2,
                ...style,
            }}
            {...textAreaProps}
            data-testid="auto-id-2efc1c5e-5af7-45e3-bd6e-6018229bf263" />
    );
};

SetEditTextArea.displayName = "SetEditTextArea";
